import { useParams } from "react-router-dom";
import { useMemo, useCallback } from "react";
import useFeature from "./useFeature";

const useNewSpectrumFormBlock = () => {
  const { featureId } = useParams();
  const feature = useFeature({ id: featureId }, { skip: featureId == null });
  const link = useCallback((rowData) => `/spectra/${rowData}`, []);

  const items = useMemo(
    () => [
      {
        id: "spectraArray",
        type: "spectraArray",
        data: feature?.data?.spectrum_ids ?? [],
        link,
      },
      { id: "notes", formOnly: true },
    ],
    [feature?.data?.spectrum_ids, link]
  );

  return items;
};

export default useNewSpectrumFormBlock;
